<template>
  <div class="mains">
    <div class="tiyouimg">
      <a href="http://123.57.205.53:8090/" target="_blank">
        <video  loop="loop"
                autoplay="autoplay"
                preload="auto"
                oncontextmenu="return false"
                controls="controls"
        >
          <source src="../assets/video/tiu.mp4" type="video/mp4">
        </video>
        <img style="object-fit: cover;width: 100%" src="../assets/img/tiyou.png"/>
      </a>
    </div>
    <div style="margin-top: 90px;height: 113px;margin-left: 17px">
      <img ref="gnjs" style="object-fit: fill;width: 50%" src="../assets/img/gnjs.png" alt="">
    </div>
    <div style="width: 100%;height: 100%;
    display: flex;
    justify-content: center;

    ">
      <div style="margin: 16px 0 160px 0;width: 100%;height: auto;display: flex;align-items: center;flex-direction: column;position:relative;font-size: 28px">

<!--        虚线1-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
            position: absolute;
            width: 3px;
            height: 9.7%;
            background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
            background-size: 100% 18px;
            background-repeat: repeat-y;
            left: 33.4%;
            top: 12%;
            z-index: 99
          "></div>
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
                position: absolute;
              width: 23.9%;
              height: 3px;
              background-image: linear-gradient(to right, rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 11px 18px;
              background-repeat: repeat-x;
              left: 9.7%;
              top: 12%;
              z-index: 99;
        ">
        </div>

<!--        虚线2-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
                position: absolute;
              width: 3px;
              height: 10%;
              background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 100% 18px;
              background-repeat: repeat-y;
              left: 36.2%;
              top: 11.8%;
              z-index: 99;
          "></div>
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
                  position: absolute;
              width: 11.9%;
              height: 3px;
              background-image: linear-gradient(to right, rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 11px 18px;
              background-repeat: repeat-x;
              left: 36.2%;
              top: 11.8%;
              z-index: 99;
        ">
        </div>
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
              position: absolute;
              width: 3px;
              height: 11%;
              background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 100% 18px;
              background-repeat: repeat-y;
              left: 47.9%;
              top: 0.8%;
              z-index: 99;
          "></div>
        <!--        虚线3-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
              position: absolute;
              width: 3px;
              height: 6.05%;
              background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 100% 18px;
              background-repeat: repeat-y;
              left: 39.2%;
              top: 15.8%;
              z-index: 99;
          "></div>
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
              position: absolute;
              width: 37.9%;
              height: 3px;
              background-image: linear-gradient(to right, rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 11px 18px;
              background-repeat: repeat-x;
              left: 39.2%;
              top: 15.8%;
              z-index: 99;
        ">
        </div>
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
              position: absolute;
              width: 3px;
              height: 16%;
              background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 100% 18px;
              background-repeat: repeat-y;
              left: 76.9%;
              /* top: 0.8%; */
              z-index: 99;
          "></div>

<!--        虚线4-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
                  position: absolute;
    width: 3px;
    height: 48%;
    background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
    background-size: 100% 18px;
    background-repeat: repeat-y;
    left: 41.9%;
    top: 22.6%;
    z-index: 99;
          "></div>
        <!--        虚线5-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
                  position: absolute;
    width: 3px;
    height: 56%;
    background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
    background-size: 100% 18px;
    background-repeat: repeat-y;
    left: 45%;
    top: 22.6%;
    z-index: 99;
          "></div>

        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
              position: absolute;
    width: 35.5%;
    height: 3px;
    background-image: linear-gradient(to right, rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
    background-size: 11px 18px;
    background-repeat: repeat-x;
    left: 9.7%;
    top: 78.4%;
    z-index: 99;
        ">
        </div>

        <!--        虚线6-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
              position: absolute;
              width: 3px;
              height: 71%;
              background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
              background-size: 100% 18px;
              background-repeat: repeat-y;
              left: 48%;
              top: 22.6%;
              z-index: 99;
          "></div>
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
        position: absolute;
    width: 32.5%;
    height: 3px;
    background-image: linear-gradient(to right, rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
    background-size: 11px 18px;
    background-repeat: repeat-x;
    left: 51%;
    top: 73.4%;
    z-index: 99;
                  ">
                  </div>

        <!--        虚线7-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="
                  position: absolute;
    width: 3px;
    height: 51%;
    background-image: linear-gradient(rgb(38, 157, 156) 0%, rgb(38, 157, 156) 80%, transparent 50%);
    background-size: 100% 18px;
    background-repeat: repeat-y;
    left: 50.9%;
    top: 22.6%;
    z-index: 99;
          "></div>
        <Circles class="xuxian"  :class="!showflag ? 'xuxian-show':''" left="9.2%" top="11.78%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="47.65%" top="0.5%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="76.68%" top="-0.22%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="33.12%" top="21.3%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="35.9%" top="21.3%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="39%" top="21.3%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="41.65%" top="22.4%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="44.78%" top="22.4%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="47.75%" top="22.4%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="50.66%" top="22.4%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="9.6%" top="78.15%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="41.65%" top="70.15%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="83%" top="73.15%" />
        <Circles class="xuxian" :class="!showflag ? 'xuxian-show':''" left="47.75%" top="93.15%" />


        <!-- -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;-->
        <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="width: 80%;height:300px;display: flex;justify-content: space-between;font-size: 20px">
          <div style="">
            <span class="fctitle">教学资源库</span>
            <br/>
            <div style="margin-top: 20px">
              <span>教学资源统一整合，</span>
              <br/>
              <span>解决教学资源碎片化的问题；</span>
              <br/>
              <span>学生教师均可访问各类资源。</span>
            </div>

          </div>
          <div>
            <span class="fctitle">1+X考证</span>
            <br/>
            题库管理
            <br/>
            智能出卷
            <br/>
            在线学习
            <br/>
            模拟认证考试平台
          </div>
          <div>
            <span class="fctitle">创新创业</span>
            <br/>
            "互联网+"项目
            <br/>
            专利孵化
            <br/>
            课题研究
            <br/>
            产教融合
          </div>
        </div>
        <div class="transform-img-div" :style="{width: tiyoupicwidth,height:tiyoupicheight}" style="display: flex;justify-content: center;">
          <img class="transform-img" :class="showflag?'transform-img-ce':'transform-img-zheng'" style="max-height: 100%;position:absolute;top: 0%" src="../assets/img/tiyoutr.png" alt="">
        </div>
        <div style="display: flex;width: 100%;height: 600px;justify-content: center">
          <div class="xuxian" :class="!showflag ? 'xuxian-show':''" style="display: flex;width: 80%;flex-wrap: wrap;justify-content: space-around">
            <div v-for="(items,index) in datalist" style="display: flex;flex-direction: column;" :style="{width:items.width,alignItems:items.local}">
              <span class="fctitle">{{items.name}}</span>
              <br/>
              <div style="width: 100%;color: #6b6868;font-size: 20px">{{items.content}}</div>
            </div>
          </div>
          <div></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Circles from "../components/Circle";
export default {
  name: "Tiyou",
  components: {
    Circles
  },
  watch:{
    showflag:function (newVal,oldVal){
      const that = this
      if(!newVal){
        window.removeEventListener('scroll',that.handleScrollx, true)
      }
    }
  },

  data(){
    return{
      datalist:[
        {
          name:'数字画像',
          content:'追踪学习，实训，模拟考试中学生的技能点掌握情况，构建精准数字画像，个性化设计能力培养方案。',
          width:'32%',
          loacl:'flex-end'
        },
        {
          name:'项目管理',
          content:'对院校申报的各项材料进行整理与资料管理，对每年度的专业建设简历资料库，沉淀专业成果。',
          width:'40%',
          loacl:'flex-end'
        },
        {
          name:'招聘就业',
          content:'实习指导、优秀毕业生跟踪、招聘就业;将院校的就业资源充分利用，合理分配到合适的学生，提高学生的就业指标。',
          width:'40%',
          loacl:'flex-start'
        },
        {
          name:'虚拟仿真',
          content:'实现基于3D图像引擎和虚拟现实(VR)的虚拟仿真实训功能。学生通过VR眼睛体验真实的操作环境，针对性提升学生实训能力。',
          width:'47%',
          loacl:'flex-start',
        }
      ],
      showflag:true,
      realwindowWidth: window.innerWidth,
      tiyoupicwidth:(window.innerWidth / 2) +'px',
      tiyoupicheight:(window.innerWidth*0.41) + 'px'
    }
  },
  mounted() {
       window.addEventListener('scroll',this.handleScrollx,true)
  },
  methods:{
    handleScrollx(){
     if(this.$refs.gnjs.getBoundingClientRect().top < 100){
       this.showflag = false
     }
    }

  },
  beforeDestroy() {
    window.removeEventListener('scroll',this.handleScrollx,true)
  },
  destroyed() {
  },
}
</script>

<style lang="scss" scoped>
  .mains{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background-color: white;
    flex-direction: column;
    display: flex;
    .tiyouimg{
      width: 100%;
      position: relative;
    }
  }

  video{
    height: 44.7%;
    width: 35.5%;
    -o-object-fit: cover;
    object-fit: cover;
    top: 26.8%;
    right: 13%;
    position: absolute;
    /*加滤镜*/
    /*-webkit-filter: grayscale(100%);*/
    /*filter:grayscale(100%);*/
  }
  .transform-img{
    transition: all 1.5s ease-in;
    -webkit-transition: all 1.5s ease-in;
  }
  .transform-img-ce{
    transform: rotateY(-20deg);
    -webkit-transform: rotateY(-20deg);
  }
  .transform-img-zheng{
    transform: rotateY(0);
    -webkit-transform: rotateY(0);
  }
  .transform-img-div{
    perspective:500;
    -webkit-perspective:500;
  }
  .fctitle{
    font-size: 32px;
    font-weight: bold;
    color: #269d9c;
  }
  .xuxian{
    opacity: 0
  }
  .xuxian-show{
    animation: anim 3s;
    opacity:1;
  }
  @keyframes anim {
    0% {opacity: 0;}
    100%{opacity:1;}
  }

</style>
